import { Typography } from "@mui/material";
import { styled } from "@mui/system";

const NonPrintHiddenTypography = styled(Typography)({
  display: "none",
  padding: "8px",
  "@media print": { display: "inherit" },
});

export function PrintOnlyTypography(props) {
  const { children } = props;
  return <NonPrintHiddenTypography>{children}</NonPrintHiddenTypography>;
}
